module.exports = __webpack_public_path__ + "29b5ae854eb551eb57f7bb769c281275.jpg";